import * as React from "react";
import { AppDispatch } from "app/store";
import { connect } from "react-redux";
import { injectIntl, WrappedComponentProps } from "react-intl";
// components
import SignUpNavbar from "common/components/signupNavbar";
import ResetPassword from "./components/resetPageComponent";
// interfaces
import { IAppState } from "../rootReducer";
// actions
import {
  ActionCreators,
  sendResetPasswordEmail,
} from "@vingle/wtf-sdk/actions/resetPassword";
// styles
import PageUpdater from "@vingle/wtf-sdk/components/pageUpdater";
const styles = require("./resetPassword.scss");

interface IResetPasswordProps
  extends ReturnType<typeof mapStateToProps>,
    WrappedComponentProps {
  dispatch: AppDispatch;
}

function mapStateToProps(state: IAppState) {
  return {
    resetPassword: state.resetPassword,
  };
}

class ResetPasswordPage extends React.Component<IResetPasswordProps> {
  public render() {
    const { intl, resetPassword } = this.props;

    return (
      <div className={styles.rootWrapper}>
        <PageUpdater title="Reset password" />
        <SignUpNavbar />
        <ResetPassword
          resetPassword={resetPassword}
          intl={intl}
          onSendEmail={this.handleSendEmail}
          onEmailChange={this.handleEmailChange}
        />
      </div>
    );
  }

  private readonly handleEmailChange = (email: string) => {
    const { dispatch } = this.props;
    dispatch(ActionCreators.setEmail({ text: email.trim() }));
  };

  private readonly handleSendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    const { dispatch, resetPassword, intl } = this.props;

    if (e) {
      e.preventDefault();
    }

    const successMSG = `${intl.formatMessage({
      id: "reset_password.success_message_title",
    })}:
     ${intl.formatMessage({ id: "reset_password.success_message_body" })}`;
    const failedMSG = `${intl.formatMessage({
      id: "reset_password.error_message_title",
    })}:
     ${intl.formatMessage({ id: "reset_password.error_message_body" })}`;

    dispatch(
      sendResetPasswordEmail(resetPassword.data.email, successMSG, failedMSG),
    );
  };
}

export default connect(mapStateToProps)(injectIntl(ResetPasswordPage));
